import { render, staticRenderFns } from "./TxnForm.vue?vue&type=template&id=a96368b2&scoped=true&"
import script from "./TxnForm.vue?vue&type=script&lang=ts&"
export * from "./TxnForm.vue?vue&type=script&lang=ts&"
import style0 from "./TxnForm.vue?vue&type=style&index=0&id=a96368b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96368b2",
  null
  
)

export default component.exports